/**
 * Batch #14.138 — Hook de polling des badges admin.
 *
 * Interroge /api/admin/badge-counts toutes les 30 secondes.
 * Retourne un objet `{sidebar, hubs}` avec les compteurs d'action.
 *
 * Usage :
 *   const { counts } = useBadgeCounts();
 *   counts.sidebar["pms-queue"]  // ex: 12
 *   counts.hubs.documents.questions  // ex: 3
 *
 * Hot revalidate possible via `revalidate()` (après un read d'item).
 */
import { useEffect, useRef, useState, useCallback } from "react";
import axios from "axios";
import { API, authH } from "@/api";

const POLL_MS = 30_000;

const EMPTY = { sidebar: {}, hubs: {} };


export function useBadgeCounts({ enabled = true } = {}) {
  const [counts, setCounts] = useState(EMPTY);
  const timer = useRef(null);

  const fetchOnce = useCallback(async () => {
    if (!enabled) return;
    try {
      const r = await axios.get(`${API}/admin/badge-counts`, { headers: authH() });
      setCounts(r.data || EMPTY);
    } catch {
      // Ne réinitialise pas si erreur (garde la dernière valeur)
    }
  }, [enabled]);

  useEffect(() => {
    if (!enabled) return undefined;
    fetchOnce();
    timer.current = setInterval(fetchOnce, POLL_MS);
    // Batch #14.142 — refresh manuel après cleanup pastilles
    const onRefresh = () => fetchOnce();
    window.addEventListener("badges:refresh", onRefresh);
    return () => {
      if (timer.current) clearInterval(timer.current);
      window.removeEventListener("badges:refresh", onRefresh);
    };
  }, [enabled, fetchOnce]);

  return { counts, revalidate: fetchOnce };
}
